import { URL,urlBuilder, URLsmall } from '../../config.js';
import { axios } from '../../handlers/RequestHandler';
import store from '../store';
import Notification from '../../handlers/Notification';
import currencyListEn from '../../assets/data/currenciesList_en.json';
import { b64toBlob, moneySymbol,FloatPrecision, localizedErrorHandler, utcDateFormat } from './UtilsOperation';
//import { renderSync } from 'node-sass';

/*function saveCompanySettings(companyId, data) {
	return axios.patch(`${URL+companyId}/settings`, data)
}

function saveCompanyData(companyId, data) {
	return axios.patch(URL + companyId, data)
}*/

//##################################################3

const fetchCompanyCountriesCities = () => {
	return (dispatch, getState) => {
		const { company, json_lang } = getState();

		return axios.get(`${URL+company.id}/countries?with=cities&limit=0`).then((res) => {
			dispatch({
				type: 'FETCH_COMPANY_COUNTRIES',
				companyCountriesCities: res.data
			})
		}).catch((err) => {
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
			});
		});
	}
}
const fetchCompanyCities = () => {
	return (dispatch, getState) => {
		const { company, json_lang } = getState();

		return axios.get(`${URL+company.id}/cities?limit=0`).then((res) => {
			dispatch({
				type: 'FETCH_COMPANY_CITIES',
				companyCities: res.data
			})
		}).catch((err) => {
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
			});
		});
	}
}

const updateCompanyCities = (city) => {
    return (dispatch,getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL + company.id}/cities/${city.id}`, city).then(() => {
            Notification.show({type: "success", title: getState().json_lang.common.success , msg: getState().json_lang.custom_success.saved_successful});
			dispatch({
				type: 'FETCH_COMPANY_CITIES',
				companyCities: city
			})
		}).catch((err) => {
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
			});
		});
    }
}

const deleteCompanyCity = (id) => {
    return (dispatch,getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL + company.id}/cities/${id}`).then(() => {
            dispatch({
				type: 'RESPONSE',
				response: true
			});
            Notification.show({type: "success", title: json_lang.common.success , msg: json_lang.custom_success.saved_successful});
		}).catch((err) => {
            dispatch({
				type: 'RESPONSE',
				response: false
			});
            Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : 'Ocurrió un error al querer eliminar la ciudad.'
			});
		});
    }
}

const fetchCompanyGeofences = () => {
	return (dispatch, getState) => {
		const { company, json_lang } = getState();

		return axios.get(`${URL+company.id}/branch-geofences?limit=0`).then((res) => {
			dispatch({
				type: 'COMPANY_GEOFENCES',
				companyGeoFences: res.data
			})
		}).catch((err) => {
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
			});
		});
	}
}

const show  = () => {
    return (dispatch,getState) => {
        return axios.get(`${URL + getState().company.id}?with=currencies`).then( (res) => {
            dispatch({
                type: 'COMPANY_PROFILE',
                company: res.data,
                initCompany: res.data,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_company });
            }
        });
    }
}
const showSettings  = () => {
    return (dispatch,getState) => {
        let { company } = getState();
        return axios.get(`${URL + getState().company.id}/settings`).then( (res) => {
            let update = company
            update.settings = res.data
            /* let estee = []
            if(update.settings.service_app_modifiers && update.settings.service_app_modifiers.length >0){
                estee= update.settings.service_app_modifiers.map( (service_app_modifier,key) => {
                    service_app_modifier.client_fee_e2 = service_app_modifier.client_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.client_fee_e2/100)) : 0
                    service_app_modifier.order_fee_e2 = service_app_modifier.order_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.order_fee_e2/100)) : 0
                    service_app_modifier.price_max_e2 = service_app_modifier.price_max_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_max_e2/100)) : 0
                    service_app_modifier.price_min_e2 = service_app_modifier.price_min_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_min_e2/100)) : 0
                    return service_app_modifier
                })
            } */
            dispatch({
                type: 'COMPANY_PROFILE',
                company:update,
                initCompany: update,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_company });
            }
        });
    }
}
const findCompany = (id) => {
    return (dispatch,getState) => {
        return axios.get(URL + id).then( (res) => {
            dispatch({
                type: 'COMPANY_PROFILE',
                company: {...res.data}
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_company });
            }
        });
    }
}

const changeCompany = id => {
    return (dispatch) => {
        return axios.get(URL + id).then( (res) => {
            dispatch({
                type: 'COMPANY_PROFILE',
                company: res.data
            })

            var customEmailFooter =
                res.data.custom_json &&
                res.data.custom_json.mail_footer ?
                res.data.custom_json.mail_footer :
                '';

            dispatch({
                type: 'COMPANY_INITIALIZATION',
                company: res.data,
                lang_code: localStorage.getItem('lang_code') || res.data.default_iso_lang,
                company_styles_json: res.data.styles_json.styles,
                currency: res.data.currency, // TODO: esto no viene de aqui,
                customEmailFooter: customEmailFooter
            })

            localStorage.setItem("companyId", res.data.id);
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.retrieving_company });
            }
        });
    }
}

const fetchCompanies  = (page = 1) => {
    return (dispatch) => {
        const url_host = URL.slice(0, -1);
        return axios.get(url_host + "?page=" + page).then((res) => {
            dispatch({
                type: 'FETCH_COMPANIES',
                companies: res.data.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.retrieving_company });
            }
        });
    }
}

const setCompanyCurrency = (iso,factor) => {
    return (dispatch,getState) => {
        var findIso = currencyListEn.findIndex(( item ) => item.value === iso );
        var newCurrency ={
            symbol:currencyListEn[findIso].symbol,
            conversion_factor:factor,
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.put(`${URL}${getState().company.id}/currencies/${iso}`,newCurrency).then( (res) => {
            Notification.show({type: "success", title: getState().json_lang.common.success , msg: getState().json_lang.custom_success.saved_successful});
            dispatch({
                type: 'COMPANY_PROFILE',
                company: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_company });
            }
        });
    }
}

const removeCompanyCurrency = (iso) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL}${getState().company.id}/currencies/${iso}`).then( (res) => {
            Notification.show({type: "success", title: getState().json_lang.common.success , msg: getState().json_lang.custom_success.saved_successful});
            dispatch({
                type: 'COMPANY_PROFILE',
                company: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_company });
            }
        });
    }
}

const email_footerChange = (input) => {
    return (dispatch,getState) => {
        var data = {
            ...getState().customEmailFooter
        };
        data = input.value;
        dispatch({
            type: 'CUSTOM_EMAIL_FOOTER',
            customEmailFooter: data
        })
    }
}

const toggleData = (value) => {
    return (dispatch, getState) => {
        var data = {...getState().company}
        let settingsX = value.name.split('_setting');
        let settingsY = value.name.split('_service_app');

        let option = value.name.split("-")

        if(value.name === 'currency_iso'){
            data.local_currency={
                iso:value.data,
                symbol:moneySymbol(value.data)
            }
        }

        else if(value.name === 'order_refresh_rate_limited' || value.name === 'order_refresh_interval_seconds'){
            data.settings.admin_app_config[value.name] = value[value.name === 'order_refresh_rate_limited' ? 'checked' : 'data'];
        }

        else if(option.length >1){
            var mValue = parseInt(value.data,10)

            if((mValue&768)!==0){
                //alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
                data.options &= ~(768 ^ mValue)
                mValue |= 256
            }

            if((mValue&(768 << 12))!==0){
                //alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
                data.options &= ~((768 << 12) ^ mValue)
                mValue |= (256 << 12)
            }

            data.options ^= mValue
        }
        else if(value.name.split("conversion_factor").length >1){
            data.currencies[parseInt(value.name.split("conversion_factor")[1],10)].conversion_factor = value.data
        }

        else if(value.name === 'decimals_count'|| value.name === 'slogan' /*|| value.name === 'delivery_fee_e2'*/){
            data.custom_json[value.name] = value.data
        }

        else if(value.name === 'in_service2'){
            data.in_service = !data.in_service;
            data.in_service2 = 1;
        }
        else if(value.name === 'color_accent'){
            console.log('color_accent',value.data)
            data.styles_json.styles.color_accent = value.data;
            data.styles_json.styles.color_primary = value.data;
		}

        else if (
            value.name === 'nearby_providers_distance' ||
            value.name === 'nearby_branches_distance' ||
            value.name === 'subcategories_count' ||
            value.name === 'contact_phone_whatsapp' ||
            value.name === 'assignable_orders_mask' ||
            value.name === 'human_delivery_discount_prc' ||
            value.name === 'human_delivery_providers_prc' ||
            value.name === 'human_delivery_fee_e2' ||
            value.name === 'contact_phone' ||
            value.name === 'uid' ||
            value.name === 'branch_invoice_tax_name' ||
            value.name === 'auto_assign_delay_minutes' ||
            value.name === 'auto_assign_bid_count' ||
            value.name === 'auto_assign_bid_attempts' ||
            value.name === 'branch_invoice_tax_prc'
        ) {
            data.settings[value.name] = value.data;
        }

        else if (
            value.name === 'disable_balance' ||
            value.name === 'pay_in_store' ||
            value.name === 'auto_assign_prepared_mode' ||
            value.name === 'disable_reports' ||
            value.name === 'enable_home_v2'
        ) {
            console.log(value.name,value.checked)
            data.settings[value.name] = value.checked;
        }

        else if(settingsX && settingsX.length >1){
            console.log("settingsX",settingsX[0])
            data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]] = settingsX[0] === "is_additional" ? value.checked : value.data;
        }

        else if(settingsY && settingsY.length >1){
            data.settings.service_app_modifiers[settingsY[1]][settingsY[0]] = value.data;
        }

        else{
            data[value.name] = value.data;
        }

		dispatch({
		    type: 'COMPANY_UPDATE',
		    company: data,
            initCompany:getState().initCompany
		})
    }
}



const toggleDataCompanyFeeds = (value) => {
    return (dispatch,getState) => {
        var data = [
            ...getState().companyDeliveryFeeds,
        ]
		let settingsX = value.name.split('_setting');
        if(settingsX[0] === "is_additional") {
            data[settingsX[1]][settingsX[0]] = value.checked;
            data[settingsX[1]].base_multiplier = 0;
            data[settingsX[1]].additional_multiplier = 0;
        } else if(settingsX[0] === "enable_days") {
            data[settingsX[1]].days = [];
        } else if (settingsX[0] === 'days') {
            const days = [...data[settingsX[1]][settingsX[0]]];
            const newValue = Number(value.data);
            const newDays = days.includes(newValue) 
            ? days.filter((day) => day !== newValue) 
            : [...days, newValue].sort();
            data[settingsX[1]][settingsX[0]] = newDays;
        } else {
            data[settingsX[1]][settingsX[0]] = value.data;
        }

		dispatch({
			type: 'FETCH_COMPANY_DELYVERY_FEEDS',
			companyDeliveryFeeds: data
		})
    }
}

const toggleGeoData = (value) => {
    return (dispatch) => {
        var data = {
            ...store.getState().company,
        }
        data.longitude_e6 = value.longitude_e6;
        data.latitude_e6 = value.latitude_e6;

        dispatch({
            type: 'COMPANY_PROFILE',
            company: { ...data }
        })
    }
}

const update = () => {
   return (dispatch,getState) => {

		let { company,initCompany } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let data={
            settings:{}
        }

        if(initCompany.local_currency !== company.local_currency){
            data.local_currency = company.local_currency
        }

        if(initCompany.currency !== company.currency){
            data.currency = company.currency// TODO=  esto no viene de aqui
        }

        if(initCompany.currency_iso !== company.currency_iso){
            data.currency_iso = company.currency_iso// TODO=  esto no viene de aqui
        }

        if(initCompany.name !== company.name){
            data.name = company.name
        }

        if(initCompany.address !== company.address){
            data.address = company.address
        }

        if(initCompany.latitude_e6 !== company.latitude_e6){
            data.latitude_e6 = company.latitude_e6
        }

        if(initCompany.latitude_e6 !== company.latitude_e6){
            data.longitude_e6 = company.longitude_e6
        }

        if(initCompany.default_iso_lang !== company.default_iso_lang){
            data.default_iso_lang = company.default_iso_lang
        }

        if(initCompany.in_service !== company.in_service){
            data.in_service = company.in_service && company.in_service === true?1:0
        }

        /* custom_json:{
            decimals_count:company.custom_json.decimals_count ? company.custom_json.decimals_count:undefined,
            uid:company.custom_json.uid ? company.custom_json.uid:undefined,
            slogan:company.custom_json.slogan ? company.custom_json.slogan:undefined,
            human_delivery_fee_e2: company.custom_json.human_delivery_fee_e2 ? company.custom_json.human_delivery_fee_e2 : undefined,
        } */
		/*if(initCompany.settings.contact_phone !== company.settings.in_service){
            data.settings.contact_phone= company.settings.contact_phone
        }*/



       /* Promise.all([
        	saveCompanySettings(company.id, data.settings),
        	saveCompanyData(company.id, data)
		])
		.then(values => {
            company.in_service2 = undefined;

            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            dispatch({
                type: 'COMPANY_UPDATE',
                company: values[1].data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });*/
    }
}

const updateCompanyInformation = () => {
    return (dispatch,getState) => {
        let { company,initCompany } = getState();
        let data = {
            settings:{}
        }

        if(initCompany.name !== company.name){
            data.name = company.name
        }

        if(initCompany.options !== company.options){
            data.options = company.options
        }

        if(initCompany.default_iso_lang !== company.default_iso_lang){
            data.default_iso_lang = company.default_iso_lang
        }

        if(initCompany.email !== company.email){
            data.email = company.email
        }

        data.settings = { uid: company.settings.uid }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}/settings`, data.settings).then( (settingsRes) => {
                axios.patch(`${URL+company.id}`, data).then((res) => {
                Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
                dispatch({
                    type: 'COMPANY_UPDATE',
                    company: {
                        ...res.data,
                        settings: settingsRes.data
                    },
                    initCompany: {
                        ...res.data,
                        settings: settingsRes.data
                    },
                })
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const updateCompanyContact = () => {
    return (dispatch,getState) => {
        let { company } = getState();
        let settings={
            admin_app_config:{
                id: (company.settings.admin_app_config && company.settings.admin_app_config.id) || null,
                order_refresh_rate_limited: (company.settings.admin_app_config && company.settings.admin_app_config.order_refresh_rate_limited) || false,
                order_refresh_interval_seconds: (
                    company.settings.admin_app_config 
                    && company.settings.admin_app_config.order_refresh_interval_seconds 
                    && Number(company.settings.admin_app_config.order_refresh_interval_seconds)
                ) || 5,
            },
            contact_phone:company.settings.contact_phone,
            contact_phone_whatsapp:company.settings.contact_phone_whatsapp,
            subcategories_count:company.settings.subcategories_count,
            nearby_providers_distance:company.settings.nearby_providers_distance,
            nearby_branches_distance:company.settings.nearby_branches_distance,
            branch_invoice_tax_name:company.settings.branch_invoice_tax_name,
            branch_invoice_tax_prc:company.settings.branch_invoice_tax_prc,
            service_app_modifiers:company.settings.service_app_modifiers,
            disable_balance:company.settings.disable_balance,
            pay_in_store:company.settings.pay_in_store,
            disable_reports:company.settings.disable_reports,
            enable_home_v2:company.settings.enable_home_v2,
            auto_assign_bid_count:company.settings.auto_assign_bid_count,
            auto_assign_bid_attempts:company.settings.auto_assign_bid_attempts,
            auto_assign_delay_minutes:company.settings.auto_assign_delay_minutes,
            auto_assign_prepared_mode:company.settings.auto_assign_prepared_mode,
        }

        if(settings.service_app_modifiers && settings.service_app_modifiers.length >0){
            settings.service_app_modifiers.map( (service_app_modifier,key) => {
                service_app_modifier.client_fee_e2 = service_app_modifier.client_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.client_fee_e2*100)) : 0
                service_app_modifier.order_fee_e2 = service_app_modifier.order_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.order_fee_e2*100)) : 0
                service_app_modifier.price_max_e2 = service_app_modifier.price_max_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_max_e2*100)) : 0
                service_app_modifier.price_min_e2 = service_app_modifier.price_min_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_min_e2*100)) : 0

                if( service_app_modifier.price_min_e2 > service_app_modifier.price_max_e2){
                    return  Notification.show({type: "error", title:service_app_modifier.name, msg:`El monto maximo no puede ser inferior al minimo`} );
                }
                return service_app_modifier
            })
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}/settings`, settings).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            company.settings=res.data
            let update = company

            if(update.settings.service_app_modifiers && update.settings.service_app_modifiers.length >0){
                update.settings.service_app_modifiers.map( (service_app_modifier,key) => {
                    service_app_modifier.client_fee_e2 = service_app_modifier.client_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.client_fee_e2/100)) : 0
                    service_app_modifier.order_fee_e2 = service_app_modifier.order_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.order_fee_e2/100)) : 0
                    service_app_modifier.price_max_e2 = service_app_modifier.price_max_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_max_e2/100)) : 0
                    service_app_modifier.price_min_e2 = service_app_modifier.price_min_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_min_e2/100)) : 0
                    return service_app_modifier
                })
            }
            dispatch({
                type: 'COMPANY_UPDATE',
                company: update,
                initCompany: update,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const updateCompanyContactPhone =() => {
    return (dispatch, getState) => {
        const { company } = getState();
        const settings = {
            contact_phone:company.settings.contact_phone,
            contact_phone_whatsapp:company.settings.contact_phone_whatsapp,
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}/settings`, settings).then(() => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const updateCompanyPaymentGeneralConfig =() => {
    return (dispatch, getState) => {
        const { company } = getState();
        const settings = {
            disable_balance:company.settings.disable_balance,
            pay_in_store:company.settings.pay_in_store
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}/settings`, settings).then(() => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );

        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const updateCompanyDeliveryDiscount = () => {
    return (dispatch,getState) => {
        let { company } = getState();
        let settings={
            human_delivery_discount_prc:company.settings.human_delivery_discount_prc
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}/settings`, settings).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            company.settings=res.data
            let update = company
            dispatch({
                type: 'COMPANY_UPDATE',
                company: update,
                initCompany: update,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}
const updateCompanyAssignableOrdersMask = () => {
    return (dispatch,getState) => {
        let { company } = getState();
        let settings={
            assignable_orders_mask:company.settings.assignable_orders_mask
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}/settings`, settings).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            company.settings=res.data
            let update = company
            dispatch({
                type: 'COMPANY_UPDATE',
                company: update,
                initCompany: update,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const updateCompanyComerci = () => {
    return (dispatch,getState) => {
        let { company } = getState();
        let settings={}
        settings.human_delivery_providers_prc= company.settings.human_delivery_providers_prc
        settings.human_delivery_fee_e2= company.settings.human_delivery_fee_e2
        dispatch({type: "WAIT_FOR_RESPONSE"})

        return axios.patch(`${URL+company.id}/settings`, settings).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            company.settings=res.data
            let update = company
            dispatch({
                type: 'COMPANY_UPDATE',
                company: update,
                initCompany: update,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}
const updateDeliverySettings = () => {
    return (dispatch,getState) => {
        let { company } = getState();

        let data={
            options:company.options
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}`, data ).then( (res) => {

            Notification.show({type: "success",
                title:getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.saved_successful} );
            dispatch({
                type: 'COMPANY_UPDATE',
                company: res.data,
                initCompany: res.data,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const updateSesionCompany = () => {
   return (dispatch,getState) => {
        var company = getState().company
        var data = {
            in_service:company.in_service && company.in_service === true?1:0,
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(URL + getState().company.id, data).then( (res) => {
            company.in_service2 = undefined;
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            dispatch({
                type: 'COMPANY_EDITING',
                company: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const deleteCompanyDeliveryFeeSteps = (keyId) => {
    return (dispatch,getState) => {
        const { companyDeliveryFeeds } = getState();
		let data = [...companyDeliveryFeeds]
        let update = companyDeliveryFeeds.filter( (step,key) => key !== keyId);
        data = update
        dispatch({
            type: 'FETCH_COMPANY_DELYVERY_FEEDS',
            companyDeliveryFeeds: data,
        })
    }
}

const addCompanyDeliveryFeeSteps = () => {
    return (dispatch,getState) => {
        const { companyDeliveryFeeds } = getState();
        let data = [...companyDeliveryFeeds];

        let step={
            name:"",
            distance_min:"",
            distance_max:"",
            human_fee_min_e2:"",
            human_fee_max_e2:"",
            human_delivery_providers_prc:"",
            hour_beg:"",
			hour_end:"",
            label:"",
            is_additional:false,
            days:[]
        }
        data.push(step);

        dispatch({
            type: 'FETCH_COMPANY_DELYVERY_FEEDS',
            companyDeliveryFeeds: data,
        })
    }
}
const updateCompanyDeliveryFeeSteps = (id) => {
    return (dispatch,getState) => {

        const { company, json_lang,companyDeliveryFeeds } = getState();
		var data = [...companyDeliveryFeeds]

        dispatch({type: "WAIT_FOR_RESPONSE"});

		let  theUpdate=data.map( (step,key) => {
			let update;
			if( step.name !== "" &&
				step.distance_min !== "" &&
				step.distance_max !== "" &&
				( step.human_fee_min_e2 !== "" && step.human_fee_min_e2 !== 0 ) &&
				( step.human_fee_max_e2 !== "" && step.human_fee_max_e2 !== 0 ) &&
				( step.human_delivery_providers_prc !=="" && step.human_delivery_providers_prc !== 0 )
			){

				update={
					name:step.name,
					distance_min:step.distance_min,
                    base_multiplier:step.base_multiplier,
                    additional_multiplier:step.additional_multiplier,
					distance_max:step.distance_max,
					human_fee_min_e2:step.human_fee_min_e2,
					human_fee_max_e2:step.human_fee_max_e2,
					human_delivery_providers_prc:step.human_delivery_providers_prc,
					hour_beg:step.hour_beg,
					hour_end:step.hour_end,
					is_additional:step.is_additional,
					label:step.label,
					days:step.days,
				}
			}
			return update
		}).filter((step) =>{
			return step !== undefined;
		})

		return axios.put(`${URL+company.id}/service-charges/${id}/delivery-fees`,theUpdate).then((res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
			dispatch({
                type: 'FETCH_COMPANY_DELYVERY_FEEDS',
                companyDeliveryFeeds: data,
            })
		}).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
			Notification.show({
				type: "error",
				title:`Error ${err && err.data && err.data.error_code}`,
				msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
			});
		});
    }
}

const addCompanyServiceApp = () => {
    return (dispatch,getState) => {
        var data = {...getState().company}
        let step={
            name:"",
            label:"",
            price_min_e2:"",
            price_max_e2:"",
            order_fee_e2:"",
            client_fee_e2:"",
            hour_beg:"",
            hour_end:"",
        }
        let update = data.settings && data.settings.service_app_modifiers.concat(step);
        data.settings.service_app_modifiers = update
        dispatch({
            type: 'COMPANY_UPDATE',
            company: data,
            initCompany:getState().initCompany
        })
    }
}

const deleteCompanyServiceApp = (keyId) => {
    return (dispatch,getState) => {
        console.log("entre",keyId)
        var data = {...getState().company}
        let update = data.settings && data.settings.service_app_modifiers.filter( (step,key) => key !== keyId);
        data.settings.service_app_modifiers = update
        dispatch({
            type: 'COMPANY_UPDATE',
            company: data,
            initCompany:getState().initCompany
        })
    }
}

const updateStyles = () => {
    return (dispatch,getState) => {
        var company = {...getState().company}
        var newData = new FormData();
        newData.append('color_primary',/*'#FF0058'*/company.styles_json.styles.color_primary)
        newData.append('color_accent', /*'#FF0058'*/company.styles_json.styles.color_accent)
        //newData.append('company_logo', data);
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL + getState().company.id+'/styles', newData).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
}

const getAppMovilStatus = () =>{
    return (dispatch,getState) => {
        return axios.get(urlBuilder +'company_app/'+ getState().company.id+'/status').then( (res) => {
            dispatch({
                type: 'APP_MOVIL_STATUS',
                appMovilStatus: res.data,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.app_status });
        });
    }
}

const getBuilderPackages = () => {
    return (dispatch,getState) => {
        return axios.get(urlBuilder + 'plans').then( (res) => {
            dispatch({
                type: 'BUILDER_PACKAGES',
                builderPackages: res.data
            })
        }).catch((err) => {
            console.log("No se ha podido traer los packs del builder")
        });
    }
}

const updateCompanyFooter = () =>{
    return (dispatch,getState) => {

        var data ={
            /*uid:getState().company.custom_json.uid,
            mail_footer: getState().customEmailFooter,
            slogan:getState().company.custom_json.slogan,*/
            human_delivery_providers_prc:getState().company.settings.human_delivery_providers_prc,
            human_delivery_fee_e2:getState().company.settings.human_delivery_fee_e2
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})

        var json_lang = getState().json_lang
        var succesful = json_lang.common.success

        return axios.patch(URL + getState().company.id+'/settings',data).then( (res) => {
            Notification.show({type: "success", title:succesful, msg:json_lang.custom_success.saved_successful});
            /*dispatch({
                type: 'UPDATE_APP_MOVIL_STATUS',
                appMovilStatus: res.data.custom_json.mail_footer
            })*/
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}


const updateMultiProvider = (value) =>{
    return (dispatch,getState) => {
        const data ={
            enable_multi_providers: value.checked
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})

        return axios.patch(URL + getState().session_company.id+'/settings',data).then( (res) => {
            Notification.show({type: "success",
                title:getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.saved_successful});

            /* setTimeout(() => {
                window.location.reload()
            }, 1000);

              var company = {...getState().company}
            company.settings = res.data
            dispatch({
                type: 'COMPANY_UPDATE',
                company: company
            })*/
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

/* TOS = Terms Of Service */
const updateCompanyTOS = () => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})

		const data = {"terms_of_service": getState().terms_of_service};
        const json_lang = getState().json_lang;
        const succesful = json_lang.common.success;

        return axios.patch(URL + getState().company.id+'/settings', data).then( (res) => {
            Notification.show({type: "success", title:succesful, msg:json_lang.custom_success.saved_successful});

		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const fetchTOS = () => {
	return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
		const json_lang = getState().json_lang;

		return axios.get(`${URL+getState().company.id}/terms-of-service`).then( (res) => {
            dispatch({
				type: 'FETCH_TOS',
				terms_of_service: res.data.terms_of_service
			})

		}).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const toggleTOSData = (input) => {
	return (dispatch) => {
		dispatch({
			type: 'FETCH_TOS',
			terms_of_service: input.value
		})
	}
}

const updateSettings = (update) => {
	return (dispatch, getState) => {
		dispatch({ type: "WAIT_FOR_RESPONSE" })
		const json_lang = getState().json_lang;
		let settings = getState().company.settings;
		let data = {};

		switch (update) {
			case "invoices":
				data.invoice_format = settings.invoice_format;
				data.enable_invoices = settings.enable_invoices;
				break;
			case "terms_of_service":
				data.terms_of_service = settings.terms_of_service;
				break;
			default: break;
		}

		return axios.patch(URL + getState().company.id + '/settings', data).then((res) => {
			let company = getState().company;
			company.settings = {...company.settings};
			Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});
			dispatch({
				type: 'COMPANY_UPDATE',
				company
			})

		}).catch((err) => {
			if (err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
		});
	}
}

const toggleSettingsData = (update) => {
	return (dispatch, getState) => {
		dispatch({ type: "WAIT_FOR_RESPONSE" });
		let data = {};
		let editable_company_settings = getState().editable_company_settings;

		switch (update.name) {
			case "invoice_size":
				data.invoice_format = editable_company_settings.invoice_format;
				data.invoice_format.paper = update.data;
				break;
			case "invoice_orientation":
				data.invoice_format = editable_company_settings.invoice_format;
				data.invoice_format.orientation = update.data;
				break;
			case "enable_invoices":
				data.enable_invoices = update.data === "true" ? false : true;
				break;
			case "terms_of_service":
				data.terms_of_service = getState().terms_of_service;
				break;
			default:
				break;
		}

		editable_company_settings = {
			...editable_company_settings,
			...data
		};

		dispatch({
			type: 'COMPANY_SETTINGS_UPDATE',
			editable_company_settings
		})
    }
}

const fetchCompanySettings = () => {
	return (dispatch,getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		// TODO: organizar configuracion para el usuario que no es branch o no es high
		const {company/*, branch*/} = getState();

		let url_host = URL + company.id + '/settings';
		/*if(branch.id)
			url_host = URL + company.id + '/branches/' + branch.id + '/settings';*/

		return axios.get(url_host).then((res) => {
            dispatch({
                type: 'FETCH_COMPANY_SETTINGS',
                editable_company_settings: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_company });
        });
    }
}

const updateCompanyClientBg = () =>{
    return (dispatch,getState) => {
        var data = new FormData();
        if(getState().dropzoneFiles.length){
            var block = getState().dropzoneFiles.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];
            var blob = b64toBlob(realData, contentType);
            data.append('company_logo', blob);
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(URL + getState().company.id+'/settings',data).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});
            dispatch({
                type: 'UPDATE_APP_MOVIL_STATUS',
                customClientBg: res.data.custom_json.mail_footer
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const companyAdjustCurrency = (value,good_conversion,property_conversion) =>{
    return (dispatch,getState) => {
        var data ={
            value: value,
            good_conversion: good_conversion,
            property_conversion: property_conversion,
        }
        var company = {...getState().company}
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${getState().company.id}/currency-adjust`,data).then( (res) => {
            var conversion_factor = res.data && res.data.currency_conversion;
            company.international_currency.conversion_factor = conversion_factor
            dispatch({
                type: 'COMPANY_UPDATE',
                company: company
            })
            Notification.show({type: "success", title: getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getPaymentMethods = (isBranch) =>{

    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+getState().company.id}${ isBranch ? `/branches/${getState().branch.id}`:``}/payment-methods/set-up`).then( (res) => {
            var method = Object.getOwnPropertyNames(res.data)
            for (var i = 0; i < method.length; i++) {
                res.data[method[i]].tax_flat_e2 = res.data[method[i]].tax_flat_e2 ? res.data[method[i]].tax_flat_e2 /100 : 0
                if(res.data[method[i]].config.validation_amount_e2){
                    res.data[method[i]].config.validation_amount_e2 = res.data[method[i]].config.validation_amount_e2 ? res.data[method[i]].config.validation_amount_e2 /100 : 0
                }
                res.data[method[i]].tax_percent = res.data[method[i]].tax_percent ? res.data[method[i]].tax_percent * 100 : 0
            }
            dispatch({
                type: 'GET_PAYMENT_METHODS',
                paymentMethods: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getPaymentMethodsForms = (noLimit) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+getState().company.id}/forms${noLimit ? `?limit=0` : ``}`).then( (res) => {
            dispatch({
                type: 'GET_PAYMENT_METHODS_FORMS',
                paymentMethodsForms: noLimit ? res.data : res.data.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getCompanyCurrencies = ()=>{
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/currencies?limit=0`).then( (res) => {
            let errorCurrencies = false;

            res.data.forEach( (curreny,key) => {
                //console.log(curreny,curreny.related_iso_error)
                if(curreny.related_iso_error === true){
                    errorCurrencies = true
                }
            })

            dispatch({
                type: 'FETCH_COMPANY_CURRENCIES',
                companyCurrencies: res.data,
                currencyError:errorCurrencies
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getCompanyCurrency = (id)=>{
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/currencies/${id}`).then( (res) => {
            dispatch({
                type: 'FETCH_COMPANY_CURRENCY',
                companyCurrency: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getCompanyPaymentMethods = () =>{
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+getState().company.id}/payment-methods`).then( (res) => {
            dispatch({
                type: 'GET_PAYMENT_METHODS',
                paymentMethods: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const togglePaymentMethods = (method,value) => {
    return (dispatch,getState) => {
        var data = {...getState().paymentMethods}
        value.name = value.name.split('-')[0]

        if(value.name === 'enabled'){
            data[method][value.name] = !data[method][value.name];
        }else{
            if(value.name ==='client_id' || value.name ==='secret_id' ||value.name ==='public_key' ||
                value.name ==='secret_key' || value.name ==='KeyId' || value.name ==='PublicKeyId'
                || value.name ==='receiver_email' || value.name ==='receiver_name' || value.name ==='authorization_key'
                || value.name ==='merchant_id' || value.name ==='username' || value.name ==='password' || value.name === 'validation_amount_e2'){
                data[method].config[value.name] = value.data;
            }else{
                data[method][value.name] = value.data;
            }
        }
        dispatch({
            type: 'GET_PAYMENT_METHODS',
            paymentMethods: data
        })
    }
}

const storePaymentMethod = (method,isBranch) => {
    console.log("storePaymentMethod",method,isBranch)
    var actionURL;
    var actionAxios;
    return (dispatch,getState) => {
        var newdata = getState().paymentMethods
        var data = getState().paymentMethods[method]

        if(method === 'paypal'){
            data.config.mode =undefined;
            data.config.validation_amount_e2 =  data.config.validation_amount_e2 ? data.config.validation_amount_e2*100 : undefined;
            if( data.enabled === true && (data.config.client_id === '' || data.config.secret_id === '' || data.config.client_id === null || data.config.secret_id === null) ){
                Notification.show({type: "error", title: 'Error al activar '+method , msg: 'cliend id y secret id deben estar llenos' });
                return
            }
        }
        if(method === 'stripe'){
            if( data.enabled === true && (data.config.public_key === '' || data.config.secret_key === '' || data.config.public_key === null || data.config.secret_key === null) ){
                Notification.show({type: "error", title: 'Error al activar '+method , msg: 'public id y secret id deben estar llenos' });
                return
            }
        }
        if(method === 'instapago'){
            if( data.enabled === true && (data.config.KeyId === '' || data.config.PublicKeyId === '' || data.config.KeyId === null || data.config.PublicKeyId === null) ){
                Notification.show({type: "error", title: 'Error al activar '+method , msg: 'KeyId y PublicKeyId id deben estar llenos' });
                return
            }
        }

        if(method === 'zelle'){
            if( data.enabled === true && (data.config.KeyId === '' || data.config.PublicKeyId === '' || data.config.KeyId === null || data.config.PublicKeyId === null) ){
                Notification.show({type: "error", title: 'Error al activar '+method , msg: 'KeyId y PublicKeyId id deben estar llenos' });
                return
            }
        }

        if(!data.in_order){
            Notification.show({type: "error", title: 'Error al activar '+method , msg: 'Debe colocar un orden de visualización' });
            return;
        }

        console.log("method ===> ",method)

        if(method === 'pos'){
            data.config.none = true;
        }

        if(method === 'banco_de_venezuela'){
            data.currency_iso=`VES`
            console.log(`averr`,data)
        }

        if(getState().paymentMethods[method].id){
            actionURL = `${URL+getState().company.id}/payment-methods/${getState().paymentMethods[method].id}`;
            actionAxios = 'patch';
        }
        else{
            actionURL = `${URL+getState().company.id}${ isBranch ? `/branches/${getState().branch.id}`:``}/payment-methods`;
            actionAxios = 'post';
        }

        data.tax_percent =  data.tax_percent ? data.tax_percent/100 : undefined;
        data.tax_flat_e2 =  data.tax_flat_e2 ? data.tax_flat_e2*100 : undefined;
        data.currency_iso =  data.currency_iso ? data.currency_iso : data.available_currencies[0];

        //data = {"name":"zelle", "enabled":true, "config":{"receiver_email":"email@email.com", "receiver_name":"Pedro Parra"}}
        return axios[actionAxios](`${actionURL}`,data).then( (res) => {
            Notification.show({type: "success", title: getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});
            newdata[method]= { ...newdata[method], id: res.data.id };

            newdata[method].tax_percent = newdata[method].tax_percent*100
            newdata[method].tax_flat_e2 = newdata[method].tax_flat_e2/100

            // dispatch({
            //     type: 'GET_PAYMENT_METHODS',
            //     paymentMethods: newdata
            // })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const destroyPaymentMethod = (method) => {
    return (dispatch,getState) => {
        return axios.delete(URL + getState().company.id+'/payment-methods/'+getState().paymentMethods[method].id).then( (res) => {
            Notification.show({type: "success", title: getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});
                getState().paymentMethods[method]=undefined
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const pendingActions = () => {
    return (dispatch,getState) => {
        return axios.get(URL + getState().company.id+'/pending-actions').then( (res) => {
            dispatch({
                type: 'GET_PENDING_ACTIONS',
                pendingActions: res.data && res.data.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const deletePendingAction = (id) => {
    return (dispatch,getState) => {
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        return axios.delete(URL + getState().company.id+'/pending-actions/'+id).then( (res) => {
            Notification.show({type: "success", title: getState().json_lang.common.success, msg:'Acción completada'});
            var actions = getState().pendingActions.filter( (item) => {
                return item.id !== id
            })

            dispatch({
                type: 'GET_PENDING_ACTIONS',
                pendingActions: actions
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const confirmPendingAction = (id) => {
    return (dispatch,getState) => {
       dispatch({ type: "WAIT_FOR_RESPONSE" });
       return axios.patch(URL + getState().company.id+'/pending-actions/'+id+'/apply').then( (res) => {
            Notification.show({type: "success", title: getState().json_lang.common.success, msg:'Cambio Aprobado'});

            var actions = getState().pendingActions.filter( (item) => {
                return item.id !== id
            })

            dispatch({
                type: 'GET_PENDING_ACTIONS',
                pendingActions: actions
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const updatePendingActionFromNotification = (payload) => {
    return (dispatch,getState) => {
        const { pendingActions } = getState();
        const updatedPendingActions = [...pendingActions];
        const findIndex = updatedPendingActions.findIndex( (item) => {
            return item.id === payload.id
        })
        if(findIndex !== -1){
            updatedPendingActions[findIndex] = payload;
        } else {
            updatedPendingActions.push(payload);
        }
        dispatch({
            type: 'GET_PENDING_ACTIONS',
            pendingActions: updatedPendingActions
        })
    }
}

const storeWorkSchedule = (data) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const { branch } = getState();
        return axios.post(`${URL+getState().company.id}/branches/${branch.id}/work-schedules`, data).then((res) => {
            dispatch({type: "WAIT_FOR_RESPONSE"})
            Notification.show({ type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'FETCH_WORK_SCHEDULES',
                workSchedules: [...getState().workSchedules, res.data]
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const storeDataWorkSchedule = (data) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const {  branch } = getState();
        return axios.put(`${URL+getState().company.id}/branches/${branch.id}/work-schedules`, data).then((res) => {
            dispatch({type: "WAIT_FOR_RESPONSE"});
            Notification.show({ type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'FETCH_WORK_SCHEDULES',
                workSchedules: [...getState().workSchedules, res.data]
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const deleteWorkSchedule = (id) => {
    return (dispatch, getState) => {
       return axios.delete(URL + getState().company.id + '/work-schedules/'+id ).then((res) => {
            dispatch({
                type: 'FETCH_WORK_SCHEDULES',
                workSchedules: getState().workSchedules.filter( deleted => deleted.id !== res.data.id)
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getWorkSchedule = () => {
    return (dispatch, getState) => {
    dispatch({type: "WAIT_FOR_RESPONSE"})
    const { branch } = getState();
       return axios.get(`${URL+getState().company.id}/branches/${branch.id}/work-schedules?limit=0`).then((res) => {
            dispatch({type: "WAIT_FOR_RESPONSE"})
            dispatch({
                type: 'FETCH_WORK_SCHEDULES',
                workSchedules: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getCompanyHolidays = () => {

    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(URL + getState().company.id + '/holidays?limit=0').then((res) => {
            dispatch({type: "WAIT_FOR_RESPONSE"});
            dispatch({
                type: 'FETCH_HOLIDAYS',
                companyHolidays: res.data
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: err.message
                });
            else
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: getState().json_lang.custom_errors.company_update_failed
                });
        });
    }
}

const storeCompanyHolidays = (data) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.put(URL + getState().company.id + '/holidays', data).then((res) => {
            dispatch({type: "WAIT_FOR_RESPONSE"});
            Notification.show({ type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'FETCH_HOLIDAYS',
                companyHolidays: [...getState().companyHolidays, res.data]
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}

const getBranchsCompany = (show,page=1,sort) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});

        return axios.get(`${URL+company.id}/branch-categories?limit=10&page=${page}
            ${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}
            ${show ? '&branch_category_id=null' : '&branch_category_id=notnull'}`)
            .then((res) => {
            //console.log('show',show,page,sort)
            //console.log(res.data)
            dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: res.data
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const toggleDataCompanyCategory = (value) => {
    return (dispatch, getState) => {
        var data = {...getState().companyCategory}

        data[value.name] = value.data;
        let thekey = value.name.split('-')

        if(thekey.length>1){
            data.children[thekey[1]][thekey[0]] = value.data
        }

        dispatch({
            type: 'FETCH_COMPANY_BRANCH_CATEGORY',
            companyCategory: data
        })
    }
}

const toggleDataSubCategory = (value) => {
    return (dispatch, getState) => {
        var data = {...getState().companySubCategory}

        data[value.name] = value.data;

        dispatch({
            type: 'FETCH_COMPANY_BRANCH_SUBCATEGORY',
            companySubCategory: data
        })
    }
}

const findBranchCompany = (branchCategoryId) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/branch-categories/${branchCategoryId}?with=children`).then((res) => {
             res.data.date_beg = res.data.date_beg
                ? utcDateFormat(res.data.date_beg, "YYYY-MM-DD HH:mm:ss")
                : null;

            res.data.date_end = res.data.date_end
                ? utcDateFormat(res.data.date_end, "YYYY-MM-DD HH:mm:ss")
                : null;
            dispatch({
                type: 'FETCH_COMPANY_BRANCH_CATEGORY',
                companyCategory: res.data
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const editBranchCompany = (data) => {
    return (dispatch, getState) => {
        const { company, json_lang, branchesCompanyCategories} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.patch(`${URL+company.id}/branch-categories/${data.id}`,data).then((res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });
            let updatebranchesCompanyCategories = branchesCompanyCategories.data.map( (category,key) => {
                if(category.id=== res.data.id){
                    category= res.data
                }
                return category
            })
            branchesCompanyCategories.data = updatebranchesCompanyCategories

            dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: branchesCompanyCategories,
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}


const addBranchCompany = (data) => {
    return (dispatch, getState) => {
        const { company, json_lang, branchesCompanyCategories} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/branch-categories`,data).then((res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });
            /*let updatebranchesCompanyCategories = branchesCompanyCategories.data.map( (category,key) => {
                if(category.id=== res.data.id){
                    category= res.data
                }
                return category
            })*/
            /* let update = branchesCompanyCategories.data.concat(res.data);
            branchesCompanyCategories.data = update */

            dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                //branchesCompanyCategories: branchesCompanyCategories,
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const addSubcaractegory = (data,category) => {
    return (dispatch, getState) => {
        const { company, json_lang /*, branchesCompanyCategories*/} = getState();
        //dispatch({type: "WAIT_FOR_RESPONSE"});
        let subcategory ={
            name:data.name,
            in_order:parseInt(data.in_order,10),
            branch_category_id:category,
        }
        return axios.post(`${URL+company.id}/branch-categories`,subcategory).then((res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });
            /*let updatebranchesCompanyCategories = branchesCompanyCategories.data.map( (category,key) => {
                if(category.id=== res.data.id){
                    category= res.data
                }
                return category
            })*/
            //let update = branchesCompanyCategories.data.concat(res.data);
            //branchesCompanyCategories.data = update

            /*dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: branchesCompanyCategories,
            })*/
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const editSubcaractegory = (data) => {
    return (dispatch, getState) => {
        const { company, json_lang/*, branchesCompanyCategories*/} = getState();
        //dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.patch(`${URL+company.id}/branch-categories/${data.id}`,data).then((res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });
            /*let updatebranchesCompanyCategories = branchesCompanyCategories.data.map( (category,key) => {
                if(category.id=== res.data.id){
                    category= res.data
                }
                return category
            })
            branchesCompanyCategories.data = updatebranchesCompanyCategories

            dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: branchesCompanyCategories,
            })*/
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const deleteSubcaractegory = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang/*, branchesCompanyCategories*/} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/branch-categories/${id}`).then((res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}
const deleteBranchCompany = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang, branchesCompanyCategories} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/branch-categories/${id}`).then((res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });

            let update_data = branchesCompanyCategories.data.filter( (category,key) => {
                return category.id !== res.data.id
            })

            branchesCompanyCategories.data = update_data
            dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: branchesCompanyCategories,
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const clearBranchCompany = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'FETCH_COMPANY_BRANCH_CATEGORY',
            companyCategory:{
                name:""
            }
        })
    }
}

const clearSubcategory = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'FETCH_COMPANY_BRANCH_SUBCATEGORY',
            companySubCategory: {
                name:"",
                in_order:null
            },
        })
    }
}

const GetbranchCategories = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        //return axios.get(`${URL+company.id}/branch-groups/${id}/branch-categories?limit=0`).then((res) => {
        return axios.get(`${URL+company.id}/branches/${id}/branch-categories?limit=0`).then((res) => {
            dispatch({
                type: 'FETCH_BRANCH_COMPANY_CATEGORIES',
                BranchCompanyCategories: res.data
            })
        }).catch((err) => {
           if (err && err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getBranchsCompanyArray = () => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/branch-categories?limit=0&with=children`).then((res) => {
            dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: res.data
            })
        }).catch((err) => {
            console.log("err",err)
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const AttachtCategoryToBranchs = (branchCategory,branchId) => {
    return (dispatch, getState) => {
        const { company, json_lang,BranchCompanyCategories} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.put(`${URL+company.id}/branch-categories/${branchCategory.id}/branches/${branchId}`).then((res) => {
            let update = BranchCompanyCategories.concat(branchCategory)

            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });
            dispatch({
                type: 'FETCH_BRANCH_COMPANY_CATEGORIES',
                BranchCompanyCategories: update
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const UnAttachCategoryToBranchs = (branchCategoryId,branchId) => {
    return (dispatch, getState) => {
        const { company, json_lang, BranchCompanyCategories} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/branch-categories/${branchCategoryId}/branches/${branchId}`).then((res) => {
            let update = BranchCompanyCategories.filter(branchCategory => branchCategory.id !== branchCategoryId)

            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg: getState().json_lang.custom_success.saved_successful
            });

            dispatch({
                type: 'FETCH_BRANCH_COMPANY_CATEGORIES',
                BranchCompanyCategories: update
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getCompanyVehicles = () => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/delivery-vehicles?limit=0`).then((res) => {
            dispatch({
                type: 'FETCH_VEHICLES',
                vehicles: res.data
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}
const getCompanyDeliveryFees = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/service-charges/${id}/delivery-fees?limit=0`).then((res) => {
            dispatch({
                type: 'FETCH_COMPANY_DELYVERY_FEEDS',
                companyDeliveryFeeds: res.data
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getCompanyServiceCharges = () => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        return axios.get(`${URL + company.id}/service-charges?limit=0`).then(res => {
            dispatch({
                type: "GET_SERVICE_CHARGES",
                serviceCharges: res.data
            });
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const setServiceCharge = (name) => {
    return (dispatch, getState) => {
        const { company, json_lang, serviceCharges } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        const data = {
            name: name,
            type: 1,
            service_type: 1
        }
        return axios.post(`${URL + company.id}/service-charges`, data).then(res => {
            dispatch({
                type: "GET_SERVICE_CHARGES",
                serviceCharges: [res.data].concat(...serviceCharges)
            });
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const pathServiceCharge = (name, id) => {
    return (dispatch, getState) => {
        const { company, json_lang, serviceCharges } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        const data = {
            name: name,
            type: 1,
            service_type: 1
        }
        let prevServiceCharges =  [ ...serviceCharges ];
        return axios.patch(`${URLsmall}service-charges/${id}`, data).then(res => {
            const i = prevServiceCharges.findIndex(index => index.id === id);
            if(i !== -1){
                prevServiceCharges[i] = { ...res.data }
            }
            dispatch({
                type: "GET_SERVICE_CHARGES",
                serviceCharges: [
                    ...prevServiceCharges
                ]
            });
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}
const deleteServiceCharge = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang, serviceCharges } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });

        return axios.delete(`${URLsmall}service-charges/${id}`).then(() => {
            dispatch({
                type: "GET_SERVICE_CHARGES",
                serviceCharges: serviceCharges.filter(charge => charge.id !== id)
            });
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.delete_successful});
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const toggleVehicleData = (value) => {
    return (dispatch, getState) => {
        var data = {...getState().vehicle}
        data[value.name] = value.data;

        dispatch({
            type: 'STORE_VEHICLE',
            vehicle: data
        })
    }
}

const createCompanyVehicles = () => {
    return (dispatch, getState) => {
        const { company, json_lang,vehicle,vehicles} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/delivery-vehicles`,vehicle).then((res) => {
            console.log("vehicles1",res.data)
            let update = vehicles.concat(res.data)
            dispatch({
                type: 'FETCH_VEHICLES',
                vehicles: update
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const deleteCompanyVehicles = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang,vehicles} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/delivery-vehicles/${id}`).then((res) => {
            let update = vehicles.filter(elm => elm.id !== parseInt(id, 10))
            dispatch({
                type: 'FETCH_VEHICLES',
                vehicles: update
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const apiReport = (urlReport) => {
    return (dispatch) => {
        if(!urlReport){
            dispatch({
                type: "REPORT",
                report: null
            });
            return;
        }
        return axios.get(urlReport).then((res) => {
            dispatch({
                type: "REPORT",
                report: res.data
            });
        }).catch((err) => {
            Notification.show({ type: "error", title: err && err.title !== '' ? err.title : `Error ${err && err.data && err.data.error_code}`, msg: err.message });
        });
    }
}

const apiReportHistories = (accountId) => {
    return (dispatch, getState) => {
        const { company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        const url = `${URL + company.id}/report-histories?limit=15`
        return axios.get(url, { account_id: accountId }).then((res) => {
            dispatch({
                type: "REPORT_HISTORIES",
                reportHistories: res.data
            });
        }).catch((err) => {
            Notification.show({ type: "error", title: err && err.title !== '' ? err.title : `Error ${err && err.data && err.data.error_code}`, msg: err && err.data && err.data.description });
        });
    }
}

const updateReportHistories = (payload) => {
    return (dispatch, getState) => {
        const { reportHistories, report } = getState();
        if(reportHistories && reportHistories.data && reportHistories.data.length > 0){
            const prevReportHistories = { ...reportHistories };
            const reportHistoryIndex = reportHistories.data.findIndex(report => report.id === payload.id);
            if(reportHistoryIndex !== -1){
                prevReportHistories.data[reportHistoryIndex].status = payload.status;
                if(payload.progress > prevReportHistories.data[reportHistoryIndex].progress){
                    prevReportHistories.data[reportHistoryIndex].progress = payload.progress;
                }
                dispatch({
                    type: "REPORT_HISTORIES",
                    reportHistories: { ...prevReportHistories }
                });
            }
        }
        if(report && (report.id === payload.id)){
            const prevReport = { ...report };
            prevReport.status = payload.status;
            if(payload.progress > prevReport.progress){
                prevReport.progress = payload.progress;
            }
            dispatch({
                type: "REPORT",
                report: { ...prevReport }
            });
        }
    }
}

const toogleCompanyCurrency = (value) => {
    return (dispatch, getState) => {
        var data = {...getState().companyCurrency}
        if( value.name ==="enabled" ||
            value.name ==="available" ||
            value.name ==="use_thousands_separator" ||
            value.name ==="is_local" ||
            value.name ==="is_custom" ||
            value.name ==="auto_sync" ||
            value.name ==="is_international"){
            data[value.name] = value.checked;
        }else{
            data[value.name] = value.data;
        }

        dispatch({
            type: 'FETCH_COMPANY_CURRENCY',
            companyCurrency: data
        })
    }
}

const clearCompanyCurrency = (value) => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_COMPANY_CURRENCY',
            companyCurrency: {
                enabled:false,
                iso:"",
                symbol:"",
                conversion_factor:"",
                related_iso:"",
                decimals_count:0,
                format:"",
                decimal_point:"",
                use_thousands_separator:false,
                auto_sync:false,
                thousands_separator:"",
                is_local:false,
                is_international:false,
                use_conversion:false,
                available:false,
            }
        })
    }
}

const createCompanyCurrency = () => {
    return (dispatch, getState) => {
        const { company, json_lang,companyCurrency,companyCurrencies} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/currencies`,companyCurrency).then((res) => {
            let update = companyCurrencies.concat(res.data)
            dispatch({
                type: 'FETCH_COMPANY_CURRENCIES',
                companyCurrencies: update
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const editCompanyCurrency = (id,branch) => {
    return (dispatch, getState) => {
        const { company, json_lang,companyCurrency,companyCurrencies,branchCurrencies} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        companyCurrency.related_iso = companyCurrency.related_iso_expected;
        console.log("editCompanyCurrency",companyCurrency)
        return axios.patch(`${URL+company.id}/currencies/${id}`,companyCurrency).then((res) => {
            let errorCurrencies = res.data.related_iso_error;

            let update = [];
            if(branch){
                update = branchCurrencies.map((item, key) => {
                    if(item.id=== parseInt(res.data.id,10)){
                        item = res.data
                    }
                    return item
                })
                dispatch({
                    type: 'FETCH_BRANCHES_CURRENCIES',
                    branchCurrencies: update
                })
            }else{
                update = companyCurrencies.map((item, key) => {
                    if(item.id=== parseInt(res.data.id,10)){
                        item = res.data
                    }
                    return item
                })
                dispatch({
                    type: 'FETCH_COMPANY_CURRENCIES',
                    companyCurrencies: update,
                    currencyError:errorCurrencies
                })
            }

        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const deleteCompanyCurrency = (id) => {
    return (dispatch, getState) => {
        const { company, json_lang,companyCurrencies} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/currencies/${id}`).then((res) => {
            let update = companyCurrencies.filter(elm => elm.id !== parseInt(id, 10))
            dispatch({
                type: 'FETCH_COMPANY_CURRENCIES',
                companyCurrencies: update
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const currencySetMode = (id,mode) => {
    return (dispatch, getState) => {
        const { company, json_lang,companyCurrencies} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/currencies/${id}/set-${mode}`).then((res) => {
            console.log("related_iso_error",res.data.related_iso_error);
            let errorCurrencies = res.data.related_iso_error;

            let update = companyCurrencies.map((item, key) => {
                if(item.id === parseInt(res.data.id,10)){
                    item = res.data
                }
                if(res.data.is_international === true && item.id !== res.data.id){
                    item.is_international=false
                }
                if(res.data.is_local === true && item.id !== res.data.id){
                    item.is_local=false
                }
                return item
            })
            dispatch({
                type: 'FETCH_COMPANY_CURRENCIES',
                companyCurrencies: update,
                currencyError: errorCurrencies
            })
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getBalanceMovements = (page = 1,sort, search='', cityId = 2, dates = null) => {
    return (dispatch, getState) => {
        const { company, json_lang,branch} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});

        //let url =`/balance-movements?type=company&key=${company.id}&page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}`
        let sort_by = sort? `&sort_by=${sort.columnName},${sort.direction}` :``
        let url = `/balance-movements?page=${page}&with=author${sort_by}${search? `&description= ilike${encodeURIComponent(search)}` :``}`;
        url+=`&type=city&key=${cityId}`;
        if(dates){
            url += `&created_at=between ${dates.dateStart} 00:00:00,${dates.dateEnd} 23:59:59`;
        }
        return axios.get(`${URL+company.id+url}`).then((res) => {
            dispatch({
                type: 'FETCH_BALANCE_MOVEMENTS',
                balanceMovements: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getBalanceDebt = (cityId) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/cities/${cityId}/balance-movements/debt`).then((res) => {
            dispatch({
                type: 'FETCH_BALANCE_DEBT',
                balanceDebt: res.data
            })
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING" });
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getProvidersBalanceMovements = (id,page = 1) => {
    return (dispatch, getState) => {
        const { json_lang,company} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        let url =`/balance-movements?type=provider&key=${id}&page=${page}`

        return axios.get(`${URL+company.id+url}`).then((res) => {
            dispatch({
                type: 'FETCH_BALANCE_MOVEMENTS',
                balanceMovements: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getClientBalanceMovements = (id,page = 1) => {
    return (dispatch, getState) => {
        const { json_lang,company} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        let url =`/balance-movements?type=client&key=${id}&page=${page}&with=author`

        return axios.get(`${URL+company.id+url}`).then((res) => {
            dispatch({
                type: 'FETCH_BALANCE_MOVEMENTS',
                balanceMovements: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}
const getClientBalanceMovement = (id) => {
    return (dispatch, getState) => {
        const { json_lang,company} = getState();
        let url =`/balance-movements/current?type=client&key=${id}`
        return axios.get(`${URL+company.id+url}`).then((res) => {
            dispatch({
                type: 'FETCH_BALANCE_MOVEMENT',
                balanceMovement: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const clearBalanceMovement = () => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_BALANCE_MOVEMENT',
            balanceMovement: null
        })
    }
}

const getClientTemporalBalanceMovements = (id,page = 1) => {
    return (dispatch, getState) => {
        const { json_lang,company} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        let url =`/balance-modifiers?page=${page}&owner_id=${id}&sort_by=id,desc`;

        return axios.get(`${URL+company.id+url}`).then((res) => {
            dispatch({
                type: 'FETCH_BALANCE_MODIFIERS',
                balanceModifiers: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}
const setBalanceMovements = () => {
    return (dispatch, getState) => {
        const { company, json_lang,newBilling,balanceMovements, session} = getState();
        // let actualBalance = balanceMovements.data.length > 0 ? balanceMovements.data[0].final_balance_e2 : 0;
        if(newBilling.type === "company" ){
            newBilling.key = company.id
        }
        let data = newBilling;
        let newBalancements = { ...balanceMovements };

        data.amount_e2 = data.amount_e2*100;
        if(newBilling.move !== "add"){
        // TODO: Aqui se evitaba que el cliente tuviera balance negativo, se pidio que se quitara
            // data.amount_e2 > actualBalance ? data.amount_e2 = -actualBalance : data.amount_e2 = -data.amount_e2

            data.amount_e2 = -data.amount_e2
        }
        dispatch({type: "WAIT_FOR_RESPONSE"});

        let url = `/balance-movements/adjust`;

        return axios.post(`${URL+company.id+url}`,data).then((res) => {
            if(newBalancements.current_page === 1){
                const author = {
                    author: {
                        email: session.email
                    }
                }
                let newMovements =  [{...res.data, ...author}].concat(newBalancements.data);
                newBalancements.data = newMovements
                dispatch({
                    type: 'FETCH_BALANCE_MOVEMENTS',
                    balanceMovements: { ...newBalancements }
                })
            } else {
                dispatch({ type: "REMOVE_LOADING" });
            }
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING" });
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const toogleBalance = (value) => {
    return (dispatch, getState) => {
        const { newBilling} = getState();
        var data = {...newBilling}

        if(value.name === 'type' && value.data === 'city'){
            data.key = value.value;
        }
        data[value.name] = value.data;
        dispatch({
            type: 'STORE_NEW_BILLING',
            newBilling: data
        })
    }
}

const resetBalance = (value) => {
    return (dispatch, getState) => {
        var data ={
            type: "company",
            key: "",
            amount_e2: "",
            notes: "",
            move:"add",
            order_ids:[]
          }

        dispatch({
            type: 'LOT_BILLING_DETAILS',
            newBilling: data,
            lotBillingsDetails:null
        })
    }
}

const getBalanceMovementBetween = (date1,date2,type) => {
    return (dispatch, getState) => {
        const { company, json_lang,branch,newBilling,provider} = getState();

        //dispatch({type: "WAIT_FOR_RESPONSE"});
        let url =`/balance-movements?type=company&key=${company.id}&report=1&created_at=between ${date1},${date2}`
        if(type === 'branch'){
            url =`/branches/${branch.id}/branch-pending-fees/report?no_invoice=1&created_at=between ${date1},${date2}`;
        }if(type === 'provider'){
            url =`/balance-movements?type=provider&key=${provider.id}&report=1&created_at=between ${date1},${date2}`;
        }

        return axios.get(`${URL+company.id+url}`).then((res) => {
            let data = res.data;
            if(type === "branch"){
                const subtotalOrder = data
                    ? data.details.reduce((acc, order) => {
                        acc += order.amount_order_e2;
                        return acc;
                    }, 0)
                    : 0;
                const subtotalFee = data
                    ? data.details.reduce((acc, order) => {
                        if(order.amount_order_e2 - order.amount_fee_e2 + order.amount_discount_e2 !== order.amount_total_e2){
                            acc += order.amount_order_e2 - order.amount_total_e2 - order.amount_fee_e2 + order.amount_discount_e2;
                        } else {
                            acc += order.amount_fee_e2;
                        }
                        return acc;
                    }, 0)
                    : 0;
                const subtotalDiscount = data
                    ? data.details.reduce((acc, order) => {
                        acc += order.amount_discount_e2;
                        return acc;
                    }, 0)
                    : 0;
                data = {
                    ...data,
                    subtotal_order_e2: subtotalOrder,
                    pending_fee_e2: subtotalFee,
                    pending_discount_e2: subtotalDiscount
                }
                newBilling.amount_e2 = data.pending_total_e2
                newBilling.order_ids = data.details.map(order => order.order_id);
            } else {
                newBilling.amount_e2 = data && data.total && data.total.split(" ")[1]
                newBilling.order_ids = data.orders.map( (order, key) => {
                    return order.order_id;
                })
            }
            dispatch({
                type: 'LOT_BILLING_DETAILS',
                lotBillingsDetails: data,
                newBilling: newBilling
            });
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}
const getBalanceMovementBetweenLot = (cityId, startDate, endDate, type) => {
    return (dispatch, getState) => {
        const { company, json_lang, newBilling} = getState();

        dispatch({type: "WAIT_FOR_RESPONSE"});
        let url = "";
        if(type === 'branch'){
            url =`/branch-pending-fees/report?no_invoice=1&created_at=between ${startDate},${endDate}${cityId ? `&city_id=${cityId}`:""}`;
        }if(type === 'provider'){
            url =`/providers/general-invoices?created_at=between ${startDate},${endDate}${cityId ? `&city_id=${cityId}`:""}`;
        }

        return axios.get(`${URL+company.id+url}`).then((res) => {
            let data = res.data;
            if(type === "branch"){
                const subtotalOrder = data
                    ? data.details.reduce((acc, order) => {
                        acc += order.amount_order_e2;
                        return acc;
                    }, 0)
                    : 0;
                data = {
                    ...data,
                    subtotal_order_e2: subtotalOrder
                }
                newBilling.amount_e2 = data.pending_total_e2
                newBilling.order_ids = data.details.map(order => order.order_id);
            } else {
                newBilling.amount_e2 = data && data.total && data.total.split(" ")[1]
                newBilling.order_ids = data.orders.map( (order, key) => {
                    return order.order_id;
                })
            }
            dispatch({
                type: 'LOT_BILLING_DETAILS',
                lotBillingsDetails: data,
                newBilling: newBilling
            });
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING" });
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}
const setBalanceMovementBetween = (type, newBillingState) => {
    return (dispatch, getState) => {
        const { company, newBilling,branch,provider} = getState();
        let data = newBilling;
        if(newBillingState){
            data = newBillingState
        }
        data.amount_e2 = - ( data.amount_e2*100 );
        data.type = 'branch';
        data.key = branch.id;
        data.relatedType = 'branches'
        let url =`/branches/${branch.id}`;
        if(type === 'provider'){
            url =`/providers/${provider.id}`;
            data.type = 'provider';
            data.key = provider.id;
            data.relatedType = 'providers'
        }

        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id+url}/general-invoices`,data).then((res) => {
            /*let newMovements =  [res.data].concat(balanceMovements.data);
            balanceMovements.data = newMovements
            dispatch({
                type: 'FETCH_BALANCE_MOVEMENTS',
                balanceMovements: balanceMovements
            })*/
            if(type === 'provider'){
                window.location.href = `/provider-management/invoice-details-${res.data.id}`
            }else{
                window.location.href = `/company-billings/invoices/${res.data.id}`
            }

        }).catch((err) => {
            console.log("err",err.message)
            Notification.show({ type: "error", title:`${err && err && err.title}`, msg: `${err && err.data && err.data.message === 'conflict' ? '¡Atención! Existe una factura pendiente. Conciliar o eliminar primero' :err && err.data && err.data.message}` });
        });
    }
}
const setBalanceMovementBetweenLot = (type, newBillingState) => {
    return (dispatch, getState) => {
        const { company, newBilling,branch,provider, json_lang } = getState();
        let data = newBilling;
        if(newBillingState){
            data = newBillingState
        }
        data.amount_e2 = - ( data.amount_e2*100 );
        data.type = 'branch';
        data.key = branch.id;
        data.relatedType = 'branches'
        let url =`/general-invoices?related_type=branches`;
        if(type === 'provider'){
            url =`/general-invoices?related_type=provider`;
            data.type = 'provider';
            data.key = provider.id;
            data.relatedType = 'providers'
        }
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id+url}`,data).then((res) => {
            if(res.data.task_queued){
                Notification.show({
                    type: "success",
                    title: json_lang.common.success,
                    msg: "El proceso de generación de las facturas se está ejecutando, irán apareciendo en la lista de facturas en breve."
                });
            } else {
                Notification.show({
                    type: "success",
                    title: json_lang.common.success,
                    msg: "Facturas generadas exitosamente."
                });
            }
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                Notification.show({
                    type: "error",
                    title: error.code,
                    msg: error.message
                });
            }else{
                Notification.show({ 
                    type: "error", 
                    title:`error`, 
                    msg: json_lang.custom_errors.default_error
                });
            }
        });
    }
}

const getGeneralInvoices = (page = 1, relatedType = "branches", conciliatedOnly = false) => {
    return (dispatch, getState) => {
        const { company, json_lang,branch} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        let url =``;
        if(branch && branch.id){
            url =`/branches/${branch.id}/general-invoices?page=${page}${conciliatedOnly ? "&status=conciliated" : ""}`;
        }else{
            url =`/general-invoices?related_type=${relatedType}&page=${page}&limit=12&with=related`;
        }
        return axios.get(`${URL+company.id+url}`).then((res) => {
            dispatch({
                type: 'FETCH_GENERAL_INVOICES',
                generalInvoices: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getGeneralProviderInvoices = (id,page = 1) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/providers/${id}/general-invoices?page=${page}`).then((res) => {
            dispatch({
                type: 'FETCH_GENERAL_INVOICES',
                generalInvoices: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const getCompanyGeneralInvoices = (limit = 10, relatedType = "branches") =>{
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        let url =`/general-invoices?related_type=${relatedType}&page=1&limit=${limit}&mode=pending&with=related`;
        return axios.get(`${URL+company.id+url}`).then((res) => {
            dispatch({
                type: 'FETCH_COMPANY_GENERAL_INVOICES',
                companyGeneralInvoices: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const deleteCompanyGeneralInvoices = (ids = []) => {
    return (dispatch, getState) => {
        const { company, json_lang, companyGeneralInvoices} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/general-invoices/batch-delete`, {data: ids}).then((res) => {
            const filteredSuccessful = res.data.filter(item => item.is_successful).map(item => item.id);
            const newCompanyGeneralInvoices = companyGeneralInvoices.data.filter(invoice => !filteredSuccessful.includes(invoice.id));
            dispatch({
                type: 'FETCH_COMPANY_GENERAL_INVOICES',
                companyGeneralInvoices: {
                    ...companyGeneralInvoices,
                    data: newCompanyGeneralInvoices
                }
            });
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.delete_successful});
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.delete_invoice_failed });
        });
    }
}

const payCompanyGeneralInvoices = (ids = [], relatedType = "branches", type = "get") => {
    return (dispatch, getState) => {
        const { company, json_lang, companyGeneralInvoices} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        const newsIds = ids.map(id => `ids[]=${id}`).join("&");
        return axios[type](`${URL+company.id}/general-invoices/batch-send-payments?mode=ids&type=${relatedType}&${newsIds}`).then((res) => {
            if(type === "get"){
                dispatch({
                    type: "FETCH_TO_PAY_COMPANY_GENERAL_INVOICES",
                    toPayCompanyGeneralInvoices: res.data
                });
            }else if (type === "post"){
                if(res && res.data && res.data.length > 0){
                    const responseIds = res.data.map(invoice => invoice.id);
                    const newCompanyGeneralInvoices = companyGeneralInvoices.data.filter(invoice => !responseIds.includes(invoice.id));
                    dispatch({
                        type: 'FETCH_COMPANY_GENERAL_INVOICES',
                        companyGeneralInvoices: {
                            ...companyGeneralInvoices,
                            data: newCompanyGeneralInvoices
                        }
                    });
                    Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.pay_successful});
                } else{
                    dispatch({type: "REMOVE_LOADING"});
                    Notification.show({ type: "warning", title:`Atención`, msg: "No se encontraron facturas para pagar" });
                }
            }
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                switch(error.code){
                    default:
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: error.message 
                        });
                    break;
                }
            } else {
                Notification.show({ 
                    type: "error", 
                    title:`Error`, 
                    msg: json_lang.custom_errors.pay_invoices_failed 
                });
            }
        });
    }
}
/* const getGeneralClientInvoices = (id,page = 1) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/client/${id}/general-invoices?page=${page}`).then((res) => {
            dispatch({
                type: 'FETCH_GENERAL_INVOICES',
                generalInvoices: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
} */
const conciliateGeneralInvoices = (generalInvoiceId) => {
    return (dispatch, getState) => {
        const { company, json_lang, invoice, companyGeneralInvoices} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/general-invoices/${generalInvoiceId}/conciliate`).then((res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            if(invoice){
                dispatch({
                    type: 'FETCH_INVOICE',
                    invoice:{
                        ...res.data,
                        items: invoice.items,
                        related: invoice.related,
                        payout_accounts: invoice.payout_accounts
                    }
                })
            }
            if(companyGeneralInvoices && companyGeneralInvoices.data && companyGeneralInvoices.data.length > 0){
                const newCompanyGeneralInvoices = {...companyGeneralInvoices};
                const index = companyGeneralInvoices.data.findIndex((item) => item.id === generalInvoiceId);
                newCompanyGeneralInvoices.data[index] = res.data;
                dispatch({
                    type: 'FETCH_COMPANY_GENERAL_INVOICES',
                    companyGeneralInvoices: newCompanyGeneralInvoices
                });
            }
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                const relatedName = (invoice.related && invoice.related.name) || "El beneficiario";
                switch(error.code){
                    case "EF607":
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: json_lang.custom_errors.target_invalid_payment_method.replace("{target}", relatedName)
                        });
                        break;
                    default:
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: error.message 
                        });
                    break;
                }
            } else {
                Notification.show({ 
                    type: "error", 
                    title:`Error`, 
                    msg: json_lang.two_steps_modal.default_error 
                });
            }
        });
    }
}
const setPaidGeneralInvoices = (generalInvoiceId,reference) => {
    return (dispatch, getState) => {
        const { company, json_lang, invoice, companyGeneralInvoices} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL+company.id}/general-invoices/${generalInvoiceId}/set-paid`, {ref: reference}).then((res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            if(invoice){
                dispatch({
                    type: 'FETCH_INVOICE',
                    invoice:{
                        ...res.data,
                        items: invoice.items,
                        related: invoice.related,
                        payout_accounts: invoice.payout_accounts
                    }
                })
            }
            if(companyGeneralInvoices && companyGeneralInvoices.data && companyGeneralInvoices.data.length > 0){
                const newCompanyGeneralInvoices = {...companyGeneralInvoices};
                const index = companyGeneralInvoices.data.findIndex((item) => item.id === generalInvoiceId);
                newCompanyGeneralInvoices.data[index] = res.data;
                dispatch({
                    type: 'FETCH_COMPANY_GENERAL_INVOICES',
                    companyGeneralInvoices: newCompanyGeneralInvoices
                });
            }
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                const relatedName = (invoice.related && invoice.related.name) || "El beneficiario";
                switch(error.code){
                    case "EF607":
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: json_lang.custom_errors.target_invalid_payment_method.replace("{target}", relatedName)
                        });
                        break;
                    default:
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: error.message 
                        });
                    break;
                }
            } else {
                Notification.show({ 
                    type: "error", 
                    title:`Error`, 
                    msg: json_lang.two_steps_modal.default_error 
                });
            }
        });
    }
}
const payGeneralInvoices = (generalInvoiceId, payoutIndex) => {
    return (dispatch, getState) => {
        const { company, json_lang, invoice, companyGeneralInvoices} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});

        let data = { send_payment: true };

        if(payoutIndex >= 0){
            data = { ...data, payout_index: payoutIndex }
        }

        return axios.post(`${URL+company.id}/general-invoices/${generalInvoiceId}/conciliate`, data).then((res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            if(invoice){
                dispatch({
                    type: 'FETCH_INVOICE',
                    invoice:{
                        ...res.data,
                        items: invoice.items,
                        related: invoice.related,
                        payout_accounts: invoice.payout_accounts
                    }
                })
            }
            if(companyGeneralInvoices && companyGeneralInvoices.data && companyGeneralInvoices.data.length > 0){
                const newCompanyGeneralInvoices = {...companyGeneralInvoices};
                const index = companyGeneralInvoices.data.findIndex((item) => item.id === generalInvoiceId);
                newCompanyGeneralInvoices.data[index] = res.data;
                dispatch({
                    type: 'FETCH_COMPANY_GENERAL_INVOICES',
                    companyGeneralInvoices: newCompanyGeneralInvoices
                });
            }

        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                const relatedName = (invoice.related && invoice.related.name) || "El beneficiario";
                switch(error.code){
                    case "EF607":
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: json_lang.custom_errors.target_invalid_payment_method.replace("{target}", relatedName)
                        });
                        break;
                    default:
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: error.message 
                        });
                    break;
                }
            } else {
                Notification.show({ 
                    type: "error", 
                    title:`Error`, 
                    msg: json_lang.two_steps_modal.default_error 
                });
            }
        });
    }
}
const retryPaymentInvoices = (generalInvoiceId, payoutIndex) => {
    return (dispatch, getState) => {
        const { company, json_lang, invoice, companyGeneralInvoices} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});

        let data = {};

        if(payoutIndex >= 0){
            data = { payout_index: payoutIndex }
        }

        return axios.post(`${URL+company.id}/general-invoices/${generalInvoiceId}/send-payment`, data).then((res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            if(invoice){
                dispatch({
                    type: 'FETCH_INVOICE',
                    invoice:{
                        ...res.data,
                        items: invoice.items,
                        related: invoice.related,
                        payout_accounts: invoice.payout_accounts
                    }
                })
            }
            if(companyGeneralInvoices && companyGeneralInvoices.data && companyGeneralInvoices.data.length > 0){
                const newCompanyGeneralInvoices = {...companyGeneralInvoices};
                const index = companyGeneralInvoices.data.findIndex((item) => item.id === generalInvoiceId);
                newCompanyGeneralInvoices.data[index] = res.data;
                dispatch({
                    type: 'FETCH_COMPANY_GENERAL_INVOICES',
                    companyGeneralInvoices: newCompanyGeneralInvoices
                });
            }

        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                const relatedName = (invoice.related && invoice.related.name) || "El beneficiario";
                switch(error.code){
                    case "EF607":
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: json_lang.custom_errors.target_invalid_payment_method.replace("{target}", relatedName)
                        });
                        break;
                    default:
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: error.message 
                        });
                    break;
                }
            } else {
                Notification.show({ 
                    type: "error", 
                    title:`Error`, 
                    msg: json_lang.two_steps_modal.default_error 
                });
            }
        });
    }
}

const editGeneralInvoices = (generalInvoiceId,body) => {
    return (dispatch, getState) => {
        const { company, json_lang, invoice, companyGeneralInvoices } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.patch(`${URL+company.id}/general-invoices/${generalInvoiceId}`, body).then((res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            if(invoice){
                dispatch({
                    type: 'FETCH_INVOICE',
                    invoice:{
                        ...res.data,
                        items: invoice.items,
                        related: invoice.related,
                        payout_accounts: invoice.payout_accounts
                    }
                })
            }
            if(companyGeneralInvoices && companyGeneralInvoices.data && companyGeneralInvoices.data.length > 0){
                const newCompanyGeneralInvoices = {...companyGeneralInvoices};
                const index = companyGeneralInvoices.data.findIndex((item) => item.id === generalInvoiceId);
                newCompanyGeneralInvoices.data[index] = res.data;
                dispatch({
                    type: 'FETCH_COMPANY_GENERAL_INVOICES',
                    companyGeneralInvoices: newCompanyGeneralInvoices
                });
            }
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                switch(error.code){
                    default:
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: error.message 
                        });
                    break;
                }
            } else {
                Notification.show({ 
                    type: "error", 
                    title:`Error`, 
                    msg: json_lang.two_steps_modal.default_error 
                });
            }
        });
    }
}

const deleteGeneralInvoices = (generalInvoiceId,type,providerId) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(`${URL+company.id}/general-invoices/${generalInvoiceId}`).then((res) => {
            /*dispatch({
                type: 'FETCH_GENERAL_INVOICES',
                generalInvoices: res.data
            })*/
            if(type === 'provider'){
                console.log("match",window.location)
                window.location.href = `/provider-management/billings-${providerId}`
            }else if(type === 'companyLot'){
                Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.delete_successful});
            }else{
                window.location.href = `/company-billings`
            }
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                switch(error.code){
                    default:
                        Notification.show({ 
                            type: "error", 
                            title:`Error ${error.code}`, 
                            msg: error.message 
                        });
                    break;
                }
            } else {
                Notification.show({ 
                    type: "error", 
                    title:`Error`, 
                    msg: json_lang.two_steps_modal.default_error 
                });
            }
        });
    }
}

const GetInvoice = (generalInvoiceId) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/general-invoices/${generalInvoiceId}?with=items.order.branch,related,city`).then((res) => {
            console.log("GetInvoice",res.data)
            dispatch({
                type: 'FETCH_INVOICE',
                invoice: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
}

const sendTwoStepsVerification = (url, method, body) => {
    return (dispatch, getState) => {
        const { json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios[method](url, body).then((res) => {
            // Notification.show({ 
            //     type: "success", 
            //     title: json_lang.common.success, 
            //     msg: json_lang.custom_success.update_successful
            // });
            dispatch({
                type: 'TWO_STEPS',
                twoSteps: {
                    error: false,
                    data: res
                }
            })
        }).catch((err) => {
            const error = err.data;
            switch(error.error_code){
                case "ET101":
                    dispatch({
                        type: 'TWO_STEPS',
                        twoSteps: {
                            error: true,
                            message: json_lang.two_steps_modal.wrong_two_steps_code
                        }
                    })
                    break;
                case "ET102":
                    Notification.show({ 
                        type: "error", 
                        title: `Error ${error.error_code}`, 
                        msg: json_lang.two_steps_modal.not_found_signature 
                    });
                    dispatch({
                        type: 'TWO_STEPS',
                        twoSteps: {
                            error: true
                        }
                    })
                    break;
                default:
                    dispatch({
                        type: 'TWO_STEPS',
                        twoSteps: {
                            error: true,
                            message: json_lang.two_steps_modal.default_error
                        }
                    })
                    break;
            }
        });
    }
}

const setBalanceModifier = (body, type, balanceModifierId) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios[type](`${URL+company.id}/balance-modifiers${balanceModifierId ? `/${balanceModifierId}` : ""}`, body).then(() => {
            Notification.show({
                type: "success", 
                title: json_lang.common.success , 
                msg: json_lang.custom_success[type === 'post' ? 'saved_successful' : 'update_successful']
            });
            dispatch({ type: "REMOVE_LOADING" });
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err && err.data && err.data.description });
        });
    }
}

export const findReference = (reference, orderId) => {
    return (dispatch, getState) => {
        const { company } = getState();
        const orderParam = orderId ? `&order_id=${orderId}` : '';
        return axios.get(`${URL+company.id}/sim-bots/search?code=${reference}${orderParam}`).then((res) => {
            dispatch({
                type: "GET_PAYMENT_REFERENCE",
                paymentReference: res.data
            })
            if(res.data && res.data.summary){
                dispatch({
                    type: "GET_ORDER_PAYMENT_SUMMARY",
                    orderPaymentSummary: { ...res.data.summary, order_id: orderId }
                })
            }
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err && err.data && err.data.description });
        });
    }
}

export const applyPayment = (orderId, referenceId) => {
    return (dispatch, getState) => {
        const { company, errorOnPaymentReference, json_lang } = getState();

        if(errorOnPaymentReference){
            dispatch({
                type: "ERROR_ON_PAYMENT_REFERENCE",
                errorOnPaymentReference: null
            })
        }

        return axios.post(`${URL+company.id}/sim-bots/${referenceId}/set-accepted`, { order_id: orderId }).then((res) => {
            if(res.data && res.data.summary){
                dispatch({
                    type: "GET_ORDER_PAYMENT_SUMMARY",
                    orderPaymentSummary: { ...res.data.summary, order_id: orderId }
                })
            }
            return res.data;
        }).catch((err) => {
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                console.log("error",error)
                dispatch({
                    type: "ERROR_ON_PAYMENT_REFERENCE",
                    errorOnPaymentReference: error
                });
            } else {
                Notification.show({
                    type: "error",
                    title: "Error",
                    msg: json_lang.custom_errors.default_error
                });
            }
        });
    }
}

export const fetchOrderPaymentSummary = (orderId) => {
    return (dispatch, getState) => {
        const { company } = getState();
        return axios.get(`${URL+company.id}/orders/${orderId}/payment-summary`).then((res) => {
            dispatch({
                type: "GET_ORDER_PAYMENT_SUMMARY",
                orderPaymentSummary: { ...res.data, order_id: orderId }
            })
        }).catch(() => {
            // backends without this endpoint: the order detail falls back to its own totals
            dispatch({
                type: "GET_ORDER_PAYMENT_SUMMARY",
                orderPaymentSummary: null
            })
        });
    }
}

export const clearPaymentReference = () => {
    return (dispatch) => {
        dispatch({
            type: "CLEAR_PAYMENT_REFERENCE",
            paymentReference: {
                approved: [],
                pending: []
            },
            errorOnPaymentReference: null
        })
    }
}

export const updateGeneralInvoice = (payload) => {
    return (dispatch, getState) => {
        const { companyGeneralInvoices, invoice } = getState();
        if(companyGeneralInvoices && companyGeneralInvoices.data && companyGeneralInvoices.data.length > 0){
            const index = companyGeneralInvoices.data.findIndex((invoice) => invoice.id === payload.id);
            if(index !== -1){
                const newCompanyGeneralInvoices = {...companyGeneralInvoices};
                newCompanyGeneralInvoices.data[index] = { ...companyGeneralInvoices.data[index], ...payload };
                dispatch({
                    type: "FETCH_COMPANY_GENERAL_INVOICES",
                    companyGeneralInvoices: newCompanyGeneralInvoices
                });
            }
        }
        if(invoice && (invoice.id === payload.id)){
            dispatch({
                type: "FETCH_INVOICE",
                invoice: { ...invoice, ...payload }
            });
        }
    }
}

export const getCompanyBanks = () => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        return axios.get(`${URL+company.id}/banks`).then((res) => {
            dispatch({
                type: "GET_BANKS",
                banks: res.data
            });
        }).catch((err) => {
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                Notification.show({ 
                    type: "error", 
                    title:`Error ${error.code}`, 
                    msg: error.message 
                });
            } else {
                Notification.show({
                    type: "error",
                    title: "Error",
                    msg: json_lang.custom_errors.default_error
                });
            }
        })
    };
};

export {
    getProvidersBalanceMovements,
    GetInvoice,
    conciliateGeneralInvoices,
    setPaidGeneralInvoices,
    payGeneralInvoices,
    retryPaymentInvoices,
    editGeneralInvoices,
    deleteGeneralInvoices,
    getBalanceMovementBetween,
    getBalanceMovementBetweenLot,
    resetBalance,
    toogleBalance,
    getBalanceMovements,
    getBalanceDebt,
    setBalanceMovements,
    setBalanceMovementBetween,
    setBalanceMovementBetweenLot,
    toggleDataCompanyFeeds,
    editCompanyCurrency,
    currencySetMode,
    deleteCompanyCurrency,
    createCompanyCurrency,
    toogleCompanyCurrency,
    clearCompanyCurrency,
    getCompanyCurrency,
    getCompanyCurrencies,
    apiReport,
    apiReportHistories,
    updateReportHistories,
    deleteCompanyVehicles,
    toggleVehicleData,
    createCompanyVehicles,
    getCompanyDeliveryFees,
    getCompanyVehicles,
    getCompanyPaymentMethods,
    clearSubcategory,
    editSubcaractegory,
    getGeneralInvoices,
    deleteSubcaractegory,
    //updateCompanySettings,
    updateCompanyInformation,
    UnAttachCategoryToBranchs,
    AttachtCategoryToBranchs,
    getBranchsCompanyArray,
    GetbranchCategories,
    clearBranchCompany,
    deleteBranchCompany,
    addBranchCompany,
    toggleDataCompanyCategory,
    editBranchCompany,
    findBranchCompany,
    getBranchsCompany,
    updateMultiProvider,
    updateCompanyClientBg,
    show,
    toggleData,
    update,
    logout,
    findCompany,
    changeCompany,
	fetchCompanies,
	fetchTOS,
	toggleTOSData,
    toggleDataSubCategory,
	fetchCompanySettings,
	toggleSettingsData,
	updateSettings,
    addSubcaractegory,
    updateCompanyDeliveryDiscount,
	updateCompanyTOS,
    toggleGeoData,
    getWorkSchedule,
    storeWorkSchedule,
    deleteWorkSchedule,
    getCompanyHolidays,
    storeCompanyHolidays,
    getAppMovilStatus,
    updateCompanyFooter,
    email_footerChange,
    companyAdjustCurrency,
    getPaymentMethods,
    getPaymentMethodsForms,
    togglePaymentMethods,
    storePaymentMethod,
    destroyPaymentMethod,
    pendingActions,
    deletePendingAction,
    confirmPendingAction,
    updatePendingActionFromNotification,
    getBuilderPackages,
    updateStyles,
    setCompanyCurrency,
    removeCompanyCurrency,
    storeDataWorkSchedule,
    updateSesionCompany,
    updateCompanyContact,
    updateCompanyComerci,
    updateDeliverySettings,
    updateCompanyDeliveryFeeSteps,
    showSettings,
    deleteCompanyDeliveryFeeSteps,
    addCompanyDeliveryFeeSteps,
    deleteCompanyServiceApp,
    addCompanyServiceApp,
    updateCompanyAssignableOrdersMask,
    fetchCompanyGeofences,
    getGeneralProviderInvoices,
    getCompanyGeneralInvoices,
    getClientBalanceMovements,
    getClientBalanceMovement,
    clearBalanceMovement,
    getClientTemporalBalanceMovements,
    fetchCompanyCountriesCities,
    fetchCompanyCities,
    updateCompanyCities,
    updateCompanyPaymentGeneralConfig,
    updateCompanyContactPhone,
    deleteCompanyCity,
    getCompanyServiceCharges,
    setServiceCharge,
    pathServiceCharge,
    deleteServiceCharge,
    deleteCompanyGeneralInvoices,
    payCompanyGeneralInvoices,
    sendTwoStepsVerification,
    setBalanceModifier
};



// WEBPACK FOOTER //
// ./src/store/actions/companyActions.js